import React, { Suspense } from 'react';
import { useProject } from '../../contexts/ProjectContext';
import { useUI } from '../../contexts/UIContext';
import { ErrorBoundary } from '../ErrorBoundary';
import { AppViewRouterProps } from './types';
import { SampleDataBanner } from './SampleDataBanner';
import { ProjectViewsRouter } from './ProjectViewsRouter';
import { GlobalViewsRouter } from './GlobalViewsRouter';
import { ConceptReportViewsRouter } from './ConceptReportViewsRouter';

export const AppViewRouter: React.FC<AppViewRouterProps> = (props) => {
  const { isProjectView, isConceptView, isRightSidebarOpen } = props;
  const projectCtx = useProject();
  const { activeProject } = projectCtx;
  const deleteSampleData = props.deleteSampleData ?? projectCtx.deleteSampleData;
  const { viewMode, setViewMode, isSidebarCollapsed } = useUI();

  const isSample = Boolean(activeProject && (activeProject.isSample || activeProject.metadata?.isSample));

  const shouldPadTop = isProjectView || isConceptView || [
    'dashboard',
    'globalCalendar',
    'globalKanban',
    'communication',
    'analysis',
    'metricsDashboard',
    'aiAssistant',
    'projectPool',
    'globalGantt'
  ].includes(viewMode);

  return (
    <main 
      data-tour="main-content"
      className="flex-1 flex flex-col transition-all duration-300 bg-white dark:bg-slate-950 overflow-hidden relative print:!m-0 print:!p-0 print:!h-auto print:overflow-visible"
      style={{ 
        marginLeft: isSidebarCollapsed ? '80px' : '320px',
        marginRight: isRightSidebarOpen ? '80px' : '0px',
        paddingTop: shouldPadTop ? '52px' : '0',
        zIndex: 0
      }}
    >
      {/* Sample Data Banner */}
      <SampleDataBanner show={isSample} onDeleteSampleData={deleteSampleData} />

      <ErrorBoundary 
        key={`${viewMode}:${activeProject?.id ?? 'global'}`}
        fallbackTitle="Fehler beim Rendern der Projektansicht"
        onReset={() => setViewMode('gantt')}
      >
        <Suspense fallback={null}>
          <ProjectViewsRouter {...props} />
          <GlobalViewsRouter {...props} />
          <ConceptReportViewsRouter {...props} />
        </Suspense>
      </ErrorBoundary>
    </main>
  );
};

export default AppViewRouter;
